import { Column, Row, Typography } from '@tempmee/react';
import { SolidStarIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';

interface IRatingContentProps {
  professionalSkills: number;
  interpersonalSkills: number;
  timeManagement: number;
}

export const RatingContent = ({
  professionalSkills,
  interpersonalSkills,
  timeManagement,
}: IRatingContentProps) => (
  <Column align="center" justify="center" gap={4}>
    {/* Legacy fontSize was 18px; no exact DS token (body_large=16, heading_4=20),
        mapped to body_large (16) as the closest token per the migration guide. */}
    <Typography bold variant="body1">
      Average Rating
    </Typography>
    {[
      { label: 'Professional Skills', value: professionalSkills },
      { label: 'Interpersonal Skills', value: interpersonalSkills },
      { label: 'Time Management', value: timeManagement },
    ].map(({ label, value }) => (
      <Column key={label} align="center" gap={1}>
        <Typography bold>{label}</Typography>
        <Row align="center" justify="center" gap={1}>
          {Array.from({ length: 5 }).map((_, i) => (
            <SolidStarIcon
              key={`${label}-${i}`}
              size={18}
              color={i < Math.floor(value) ? colors.success['400'] : colors.neutral['200']}
            />
          ))}
          <Typography>{value.toFixed(1)}</Typography>
        </Row>
      </Column>
    ))}
  </Column>
);
